export default __webpack_public_path__ + "static/media/coin_gbp.df241d7a.svg";